const map = {
	"./carousel2_controller.js": 6546,
	"./culture_controller.js": 2496,
	"./header_controller.js": 2385,
	"./home_controller.js": 7559,
	"./home_ie11_controller.js": 7818,
	"./main_controller.js": 2113,
	"./publications_controller.js": 4763,
	"./scroll_controller.js": 4045,
	"./scroll_ie11_controller.js": 3560,
	"./service_controller.js": 3323,
	"controllers/carousel2_controller.js": 6546,
	"controllers/culture_controller.js": 2496,
	"controllers/header_controller.js": 2385,
	"controllers/home_controller.js": 7559,
	"controllers/home_ie11_controller.js": 7818,
	"controllers/main_controller.js": 2113,
	"controllers/publications_controller.js": 4763,
	"controllers/scroll_controller.js": 4045,
	"controllers/scroll_ie11_controller.js": 3560,
	"controllers/service_controller.js": 3323
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8887;